<template>
  <body
    data-spy="scroll"
    data-offset="60"
    data-target=".nav__holder"
    data-cookie="on"
    id="home"
    itemscope
    itemtype="http://schema.org/WebPage"
  >

  <main class="main-wrap">
      <div class="content-wrap">
        <Welcome/>     
      </div>
      
      <!-- end content wrap -->
      
      <div id="back-to-top">
        <a href="#top">
          <i class="ui-arrow-up"></i>
        </a>
      </div>
    </main>
    <!-- end main wrapper -->

  </body>
</template>

<script>
import Welcome from '@/components/Welcome.vue'

export default{
  components:{
    Welcome,
  }
};

</script>

<style lang="scss">

</style>